import { queryOptions } from '@tanstack/react-query';
import { traceClient } from '@terra/shared-rest-clients-trace';
import { getAuthHeaders } from '../../utils/authHeaders';
import { getCurrentGatewayUrl } from '../../utils/environmentDetection';

export const NEO_EXECUTIONS_AGENT_NAME = 'neo';

const NEO_EXECUTIONS_COUNTS_STALE_TIME_MS = 30_000;

const requestNeoExecutionsCounts = async ({
  applicationId,
  startDate,
  groupByStatus,
}: {
  applicationId: string;
  startDate?: Date;
  groupByStatus: boolean;
}) => {
  const authHeaders = await getAuthHeaders();
  const result = await traceClient.getTracesCountByApplicationId({
    params: { applicationId },
    query: {
      agentName: NEO_EXECUTIONS_AGENT_NAME,
      ...(startDate && { startDate }),
      ...(groupByStatus && { groupByStatus }),
    },
    overrideClientOptions: {
      baseUrl: `${getCurrentGatewayUrl()}/ai`,
    },
    extraHeaders: authHeaders,
  });

  return result.status === 200
    ? result.body
    : { total: 0, byStatus: undefined };
};

export const fetchNeoExecutionsCount = async ({
  applicationId,
  startDate,
}: {
  applicationId: string;
  startDate?: Date;
}): Promise<number> => {
  const { total } = await requestNeoExecutionsCounts({
    applicationId,
    startDate,
    groupByStatus: false,
  });

  return total;
};

export const neoExecutionsCountsQueryOptions = (applicationId: string) =>
  queryOptions({
    queryKey: ['neo-executions-counts', applicationId],
    queryFn: () =>
      requestNeoExecutionsCounts({ applicationId, groupByStatus: true }),
    staleTime: NEO_EXECUTIONS_COUNTS_STALE_TIME_MS,
  });
